<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <!-- <right-nav></right-nav> -->
    <home-nav></home-nav>
    <div>
      <div class="w">
        <div class="site-nav">
          <router-link :to="{ name: 'index' }">首页</router-link>>
          <router-link :to="{ name: 'user-center' }">个人中心</router-link>>
          个人信息
        </div>
        <left-userinfo :name="name"></left-userinfo>
        <div class="right-user-wrap">
          <div class="title">
            <h2>个人信息</h2>
          </div>
          <ul class="info-body">
            <li class="info-avatar">
              <span>头像</span>

              <!-- :src="userInfo.companyInfo && userInfo.companyInfo.avatar" -->
              <div
                class="img"
                :style="'background-image: url(' + avatar + ')'"
              ></div>
              <!-- <img
                src="https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2111934553,104502141&fm=26&gp=0.jpg"
                align="center"
                alt="avatar"
              />-->
            </li>
            <li v-if="userInfo.name">
              <span>用户名</span>
              {{ userInfo.name }}
            </li>
            <li>
              <span>手机号码</span>
              {{ userInfo.phone }}
            </li>
            <li v-if="userInfo.companyInfo && userInfo.companyInfo.sex">
              <span>性别</span>
              {{ userInfo.companyInfo && userInfo.companyInfo.sex }}
            </li>
            <li v-if="userInfo.companyInfo && userInfo.companyInfo.birthday">
              <span>出生日期</span>
              {{
                userInfo.companyInfo &&
                  userInfo.companyInfo.birthday | dateFormat
              }}
            </li>
            <li v-if="allow_change_password && userInfo.email">
              <span>账号安全</span>
              <a style="cursor: pointer;" @click.once="gotoChangePassword"
                >修改密码></a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import LeftUserinfo from "@/components/left-userinfo";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    LeftUserinfo
  },
  data() {
    return {
      name: "",
      userInfo: "",
      avatar: "",
      allow_change_password: false
    };
  },
  mounted() {
    this.getData();
    this.getActivity();
  },
  created() {
    this.name = this.$route.query.name;
    this.$bus.on("change-activity", this.getActivity);
  },
  beforeDestroy() {
    this.$bus.$off("change-activity"); //当这个组件销毁的时候bus也跟着一起销毁
  },
  methods: {
    getData() {
      this.$reqGet("api/usercenter/info").then(res => {
        this.userInfo = res.data.data;
        if (this.userInfo.companyInfo && this.userInfo.companyInfo.avatar) {
          this.avatar = this.userInfo.companyInfo.avatar;
        }
      });
    },
    getActivity() {
      this.allow_change_password = false;
      this.$reqGet("api/ecomm/home/pc_home").then(res => {
        this.allow_change_password =
          res.data.data.activity.products.allow_change_password;
      });
    },
    gotoChangePassword() {
      this.$router.push({ name: "change-password" });
    }
  }
};
</script>

<style lang="less" scoped>
.site-nav {
  padding: 20px 0;
  color: #999;
  font-size: 16px;
  a {
    color: #999;
  }
  a:first-child {
    color: #444;
  }
}
.right-user-wrap {
  // position: relative;
  margin-bottom: 40px;
  min-height: 572px;
  width: 980px;
  margin-left: 220px;
  box-sizing: border-box;
  padding: 10px 25px 0;
  background-color: #fff;
  .title {
    line-height: 42px;
    height: 42px;
    border-bottom: 2px solid #dadada;
    margin-bottom: 30px;
    h2 {
      display: inline-block;
      border-bottom: 2px solid #e2333f;
      font-size: 20px;
      font-weight: normal;
      margin: 0;
      box-sizing: border-box;
      padding: 0 20px;
    }
  }
  .info-body {
    li {
      margin-bottom: 30px;
      display: flex;
      span {
        display: inline-block;
        width: 60px;
        text-align-last: justify;
        margin-right: 40px;
      }
      .img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background-size: cover;
        background-position: 50% 50%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-center.vue